import React from "react";
import { IconButton } from "@material-ui/core";
import { Edit as EditIcon, Delete as DeleteIcon } from "@material-ui/icons";

type Props = {
  data: any;
  type: "edit" | "delete";
  onClick: (data: any) => void;
};

export const Action: React.FC<Props> = (props) => {
  function onClick() {
    props.onClick(props.data);
  }

  return (
    <IconButton size="small" onClick={onClick}>
      {props.type === "edit" ? <EditIcon fontSize="small" /> : null}
      {props.type === "delete" ? <DeleteIcon fontSize="small" /> : null}
    </IconButton>
  );
};
